var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#287C87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 28C42 30.3704 41.616 32.5407 40.8481 34.5111C40.0802 36.4667 38.9947 38.1481 37.5918 39.5556C36.2036 40.963 34.5274 42.0593 32.5633 42.8444C30.6139 43.6148 28.443 44 26.0506 44H14V12H26.0506C28.443 12 30.6139 12.3926 32.5633 13.1778C34.5274 13.9481 36.2036 15.037 37.5918 16.4444C38.9947 17.8519 40.0802 19.5407 40.8481 21.5111C41.616 23.4667 42 25.6296 42 28ZM36.7057 28C36.7057 26.163 36.4546 24.5111 35.9525 23.0444C35.4652 21.5778 34.7563 20.3407 33.8259 19.3333C32.9103 18.3259 31.7954 17.5556 30.481 17.0222C29.1667 16.4741 27.6899 16.2 26.0506 16.2H19.2057V39.8H26.0506C27.6899 39.8 29.1667 39.5333 30.481 39C31.7954 38.4667 32.9103 37.6963 33.8259 36.6889C34.7563 35.6667 35.4652 34.4296 35.9525 32.9778C36.4546 31.5111 36.7057 29.8519 36.7057 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDIcon);
export default __webpack_public_path__ + "static/media/d-icon.82539869d2609b5473779ea585ffe993.svg";
export { ForwardRef as ReactComponent };